module.exports = __webpack_public_path__ + "53a565632580372fd7162539df743790.ttf";